module.exports = __webpack_public_path__ + "img/icon.709acf32.png";